
import TableList from "@components/templates/tablelist";
import {
    HttpReimbursementManageList,
    HttplogOrderAction,
    HttpBatchAddRemark,
    HttpBatchComplete,
    HttpBatchAudit,
    HttpCountReimbursementManageList
} from "@/service/reimbursement";
// 索赔单
import mixin from "./mixin";
import {
    mapGetters
} from 'vuex';
import compDetail from './update';
import compModal from './compModal'
export default {
    mixins: [TableList, mixin],
    components: {
        compMutiUpload: () => import("@components/templates/mutiUpload"),
        compDetail,

    },
    data() {
        return {
            opAttachMeta: "",
            attachMetas: {
                items: [],
                opAt: "",
                organizationId: ""
            },
            nowTime:"",
            systemDate:"",
            isMixin: true,
            Tools: {
                show: true
            },
            Tabs: {
                show: true
            },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,

            },
            sum: {
                toAduit: 0,
                refuse:0,
                processing:0,
                complete: 0,
                compensation:0,
                overTime:0,
            },
            Plugins: {
                show: true
            },
            searchOptions: {
                reimbursementReason: []
            },
            checkWarehouse:false,
            allPermissionsL:false
        };
    },
    created(){
        this.allPermissions = this.handleAuth("fbb.reim.allpermissions");
        if(!this.allPermissions){
            this.checkWarehouse = this.handleAuth("fbb.reim.warehouse");
        }
        console.log(this.checkWarehouse);
        this.nowTime = new Date();
        let mon = this.nowTime.getMonth() + 1 ;
        let date = {
            year: this.nowTime.getFullYear(),
            month: (this.nowTime.getMonth() + 1) < 10 ? "0" + mon : this.nowTime.getMonth() + 1,
            date: this.nowTime.getDate() < 10 ? "0" + this.nowTime.getDate() : this.nowTime.getDate(),
        }
        this.systemDate = date.year + '-' + date.month + '-'  + date.date;
        /* this.getSum(); */
    },
    methods: {
        ajaxRequest: HttpReimbursementManageList,
        interceptResponse(){
            this.getSum();
        },
        interceptRequest(params) {
            const { CN_propsCarrier,CN_propsTracking,CN_detailTracking,CN_warehouseCode,LT_reviewAt,CN_reimbursementNo } = params.search;
            let propsCarrier,propsTracking,detailTracking,warehouseCode,IN_reimbursementNo;
            if(CN_propsCarrier){
                propsCarrier = "\"saleCarrier\":"+"\""+CN_propsCarrier+"\"";
            }
            if(CN_propsTracking){
                propsTracking = "\"trackingNo\":"+"\""+params.search.CN_propsTracking+"\"";
            }
            if(CN_detailTracking){
                detailTracking = "\"trackingNo\":"+"\""+params.search.CN_detailTracking+"\"";
            }
            if(CN_warehouseCode){
                warehouseCode = "\"warehouseCode\":"+"\""+params.search.CN_warehouseCode+"\"";
            }
            if(LT_reviewAt){
                params.search. EQ_status = 4
            }
            if(CN_reimbursementNo){
                IN_reimbursementNo = params.search.CN_reimbursementNo.replace(/\n/g,",");
            }
            params.propsSku = params.search.IN_propsSku
            params.propsCarrier = propsCarrier
            params.propsTracking = propsTracking
            params.detailTracking = detailTracking
            params.warehouseCode = warehouseCode
            params.search.IN_reimbursementNo = IN_reimbursementNo;

            delete params.search.CN_propsCarrier;
            delete params.search.IN_propsSku;
            delete params.search.CN_propsTracking;
            delete params.search.CN_detailTracking;
            delete params.search.CN_warehouseCode;
            delete params.search.CN_reimbursementNo;
            return this.handleParams(params);
        },
        handleParams(params){
            /* if(params.search.CN_propsCarrier){
                params.propsCarrier = "\"saleCarrier\":"+"\""+params.search.CN_propsCarrier+"\"";
                this.formData.propsCarrier = "\"saleCarrier\":"+"\""+params.search.CN_propsCarrier+"\"";
                params.search.CN_propsCarrier = "";
                this.formData.search.CN_propsCarrier = "";
            }else{
                params.propsCarrier = "";
                this.formData.propsCarrier = "";
            }
            if(params.search.CN_propsTracking){
                params.propsTracking = "\"trackingNo\":"+"\""+params.search.CN_propsTracking+"\"";
                this.formData.propsTracking = "\"trackingNo\":"+"\""+params.search.CN_propsTracking+"\"";
                params.search.CN_propsTracking = "";
                this.formData.search.CN_propsTracking = "";
            }else{
                params.propsTracking = "";
                this.formData.propsTracking = "";
            }
            if(params.search.CN_warehouseCode){
                params.warehouseCode = "\"warehouseCode\":"+"\""+params.search.CN_warehouseCode+"\"";
                this.formData.warehouseCode = "\"warehouseCode\":"+"\""+params.search.CN_warehouseCode+"\"";
                params.search.CN_warehouseCode = "";
                this.formData.search.CN_warehouseCode = "";
            }else{
                params.warehouseCode = "";
                this.formData.warehouseCode = "";
            }
            if(params.search.LT_reviewAt){
                params.search. EQ_status = 4
            }
            if(params.search.CN_reimbursementNo){
                params.search.IN_reimbursementNo = params.search.CN_reimbursementNo.replace(/\n/g,",");
            }
            delete params.search.sku;
            delete params.search.CN_reimbursementNo; */
            return params

        },
        getSum(){
            HttpCountReimbursementManageList({
                contextId: global.SYSID,
            })
            .then(res => {
                this.sum.toAduit = res.data.toAduit;
                this.sum.refuse = res.data.refuse;
                this.sum.processing = res.data.processing;
                this.sum.complete = res.data.complete;
                this.sum.compensation = res.data.compensation;
                this.sum.overTime = res.data.overTime
            });
            /* HttpReimbursementManageList({
                contextId: global.SYSID,
                search: {
                    LT_reviewAt: this.systemDate,
                    EQ_status : 4
                }
            })
            .then(res => {
                this.sum.overTime = res.data.totalElements
            }); */
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {

                case "query":
                    this.operate = {
                        title: '详情',
                        show: true,
                        width: 1200,
                        component: "compDetail",
                        activeid: params,
                        querytype: 'adminQuery',
                        showFooter: false
                    }
                    break;
                case 'queryBlank':
                    window.open(this.$router.resolve({
                        name: "reimbursementUpdate",
                        params: {
                            type: 'adminQuery'
                        },
                        query: {
                            id: params
                        },
                    }).href, '_blank');
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "取消",
                        width: 460,
                        showDesc: false,
                        params: {
                            headId: params,
                            opAction: 7
                        },
                        ajaxRequest: HttplogOrderAction,
                        formdata: [{
                            tag: "vTextarea",
                            key: "opData",
                            labelWidth: 'auto',
                            span: 24,
                            label: "取消原因"
                        }]
                    };
                    break;
                case "addRemark":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: "备注",
                        width: 460,
                        component: compModal,
                        showFooter: false,
                        showDesc: false,
                        headId: params,
                        type:'addRemark'

                    };
                    break;
                    case "complete":
                        this.operate = {
                            show: true,
                            alert: "success",
                            title: "平台完成",
                            width: 460,
                            showDesc: false,
                            callback: this.goback,
                            params: {
                              headId: params.id,
                              opAction: 9
                            },
                            ajaxRequest: HttplogOrderAction,
                            formdata: [
                                {
                                    tag: "vRadio",
                                    key: "isComplete",
                                    labelWidth: 'auto',
                                    default: 1,
                                    span: 24,
                                    show:params.reimbursementType==2||params.reimbursementReason==10,
                                    options: [{
                                        trueValue: 1,
                                        label: '索赔成功',
                                    }, {
                                        trueValue: 2,
                                        label: '索赔失败',
                                    }]
                                },
                                {
                                    label: "caseId",
                                    key: "caseId",
                                    tag: "Input",
                                    labelWidth: "auto",
                                    span: 24,
                                    required: false
                                },
                              {
                                tag: "vTextarea",
                                key: "opData",
                                labelWidth: "auto",
                                span: 24,
                                label: "备注原因",
                                required: false
                              }
                            ]
                        };
                        break;
                        case "checkBill":
                            this.operate = {
                                show: true,
                                alert: "success",
                                title: "调账",
                                width: 460,
                                component: compModal,
                                showFooter: false,
                                showDesc: false,
                                headId: params,
                                type:'checkBill'
                            };
                    break;
                    case "compensation":
                        this.operate = {
                            show: true,
                            alert: "success",
                            title: "赔付完成",
                            width: 460,
                            showDesc: false,
                            callback: this.goback,
                            params: {
                              headId: params.id,
                              opAction: 11
                            },
                            ajaxRequest: HttplogOrderAction,
                            formdata: [
                                {
                                    label: "实际发票金额",
                                    key: "actualInvoiceAmount",
                                    tag: "vInputNumber",
                                    labelWidth: "auto",
                                    span: 24,
                                    required: false
                                },
                            ]
                        };
                        break;
                case "batchAddRemark":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: "备注",
                        width: 460,
                        showDesc: false,
                        params: {
                            ids: params,
                            opAction: 6
                        },
                        ajaxRequest: HttpBatchAddRemark,
                        formdata: [{
                            tag: "vTextarea",
                            key: "opData",
                            labelWidth: 'auto',
                            span: 24,
                            label: "备注"
                        }]
                    };
                    break;
                    case "batchComplete":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: "批量完成",
                        width: 460,
                        showDesc: false,
                        params: {
                            ids: params
                        },
                        ajaxRequest: HttpBatchComplete,
                        formdata: [{
                            tag: "vRadio",
                            key: "isComplete",
                            labelWidth: 'auto',
                            default: 1,
                            span: 24,
                            options: [{
                                trueValue: 1,
                                label: '索赔成功',
                            }, {
                                trueValue: 2,
                                label: '索赔失败',
                            }]
                        },
                        {
                            label: "caseId",
                            key: "caseId",
                            tag: "Input",
                            labelWidth: "auto",
                            span: 24,
                            required: false
                        },{
                            tag: "vTextarea",
                            key: "opData",
                            labelWidth: 'auto',
                            span: 24,
                            label: "备注",
                            required: false
                        }]
                    };
                    break;
                case "audit":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: "审核",
                        width: "400px",
                        showDesc: false,
                        component: compModal,
                        showFooter: false,
                        headId: params,
                        type:'aduit'
                        /* params: {
                            headId: params,
                        },
                        ajaxRequest: HttplogOrderAction,
                        formdata: [{
                                tag: "vRadio",
                                key: "opAction",
                                labelWidth: 'auto',
                                default: 4,
                                span: 24,
                                label: "审核",
                                options: [{
                                    trueValue: 4,
                                    label: '审核通过',
                                }, {
                                    trueValue: 5,
                                    label: '审核拒回',
                                }]
                            },
                            {
                                label: "复核日期",
                                tag: "vDatepicker",
                                labelWidth: "auto",
                                key: "reviewAt",
                                span: 24,
                                props: {
                                  format: "yy-mm-dd"
                                },
                                required: false
                              },
                            {
                                tag: "vTextarea",
                                key: "opData",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注",
                                required: false
                            }
                        ] */
                    };
                    break;
                    case "batchAudit":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: "批量审核",
                        width: "400px",
                        showDesc: false,
                        params: {
                            ids: params,
                        },
                        ajaxRequest: HttpBatchAudit,
                        formdata: [{
                                tag: "vRadio",
                                key: "opAction",
                                labelWidth: 'auto',
                                default: 4,
                                span: 24,
                                label: "审核",
                                options: [{
                                    trueValue: 4,
                                    label: '审核通过',
                                }, {
                                    trueValue: 5,
                                    label: '审核拒回',
                                }]
                            },{
                                label: "caseId",
                                key: "caseId",
                                tag: "Input",
                                labelWidth: "auto",
                                span: 24,
                                required: false
                            },
                            {
                                label: "复核日期",
                                tag: "vDatepicker",
                                labelWidth: "auto",
                                key: "reviewAt",
                                span: 24,
                                props: {
                                  format: "yy-mm-dd"
                                },
                                required: false
                              },
                            {
                                tag: "vTextarea",
                                key: "opData",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注",
                                required: false
                            }
                        ]
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/reimbursement/Reimbursement/manageExport', this.interceptRequest(JSON.parse(JSON.stringify(this.formData))), { executor: 'request', download: true })
                    break;
                case 'billExport':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/reimbursement/Reimbursement/manageExportBill', this.interceptRequest(JSON.parse(JSON.stringify(this.formData))), { executor: 'request', download: true })
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: "赔付完成导入",
                        showDesc: false,
                        component: "compUpload",
                        name: "excelFile",
                        width:450,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/reimbursement/Reimbursement/importDataByManage",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/reimbursement/Reimbursement/importTemplateByManage", {}, {
                                executor:'request',
                                download:true,
                            })
                        },
                        callback:()=>{
                            this.$emit('on-update');
                            this.operate = {};
                        }
                    };
                    break;
                case 'importByPlatform':
                    this.operate = {
                        show: true,
                        title: "平台完成导入",
                        showDesc: false,
                        component: "compUpload",
                        name: "excelFile",
                        width:450,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/reimbursement/Reimbursement/importDataByPlatform",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/reimbursement/Reimbursement/importTemplateByPlatform", {}, {
                                executor:'request',
                                download:true,
                            })
                        },
                        callback:()=>{
                            this.$emit('on-update');
                            this.operate = {};
                        }
                    };
                    break;
                case 'importByReview':
                    this.operate = {
                        show: true,
                        title: "审核结果导入",
                        showDesc: false,
                        component: "compUpload",
                        name: "excelFile",
                        width:450,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/reimbursement/Reimbursement/importDataByReview",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/reimbursement/Reimbursement/importTemplateByReview", {}, {
                                executor:'request',
                                download:true,
                            })
                        },
                        callback:()=>{
                            this.$emit('on-update');
                            this.operate = {};
                        }
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const {
                id,
                status: status,
                isComplete,
            } = row
            return [{
                label: '查看详情',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '审核',
                show: status == 2,
                params: id,
                operate: 'audit'
            }, {
                label: '添加备注',
                show: status == 4,
                params: id,
                operate: 'addRemark'
            },
            {
                label: '调账',
                show: status == 4,
                params: id,
                operate: 'checkBill'
            },
             {
                label: '平台完成',
                show: status == 4,
                params: row,
                operate: 'complete'
                },
                {
                    label: '赔付完成',
                    show: status == 5 && isComplete == 1,
                    params: row,
                    operate: 'compensation'
                },
            {
                label: '取消',
                show: status == 1 || status == 2 || status == 3,
                params: id,
                operate: 'cancel'
            }
        ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList','getCusproductList','getAllProduct','getSelfmanageorgList','getUserManageWarehouseList']),
        TabsData() {
            if(!this.allPermissions&&this.checkWarehouse){
                return [{
                    name: "平台完成"+ '（' + this.sum.complete + '）',
                    key: 'EQ_status',
                    value: 5
                }]
            }else{
                return [{
                    name: "所有",
                    key: 'EQ_status',
                    value: null
                }, {
                    name: "待审核" + '（' + this.sum.toAduit + '）',
                    key: 'EQ_status',
                    value: 2
                }, {
                    name: "审核拒回" + '（' + this.sum.refuse + '）',
                    key: 'EQ_status',
                    value: 3
                }, {
                    name: "处理中" + '（' + this.sum.processing + '）',
                    key: 'EQ_status',
                    value: 4
                }, {
                    name: "平台完成"+ '（' + this.sum.complete + '）',
                    key: 'EQ_status',
                    value: 5
                }, {
                    name: "赔付完成"+ '（' + this.sum.compensation + '）',
                    key: 'EQ_status',
                    value: 7
                }, {
                    name: "超时复核"+ '（' + this.sum.overTime + '）',
                    key: 'LT_reviewAt',
                    value:this.systemDate
                }]
            }
        },
        ToolsData() {
            return [{
                    name: "导出",
                    operate: "export",
                    theme: "info",
                },
                {
                    name: "审核结果导入",
                    operate: "importByReview",
                    more:true,
                },
                {
                    name: "平台完成导入",
                    operate: "importByPlatform",
                    more:true,
                },
                {
                    name: "赔付完成导入",
                    operate: "import",
                    more:true,
                },
                {
                    name: "批量备注",
                    operate: "batchAddRemark",
                    batch: true,
                    more:true,
                },
                {
                    name: "批量审核",
                    operate: "batchAudit",
                    batch: true,
                    more:true,
                },
                {
                    name: "批量完成",
                    operate: "batchComplete",
                    batch: true,
                    more:true,
                },
                {
                    name: "账单索赔导出",
                    operate: "billExport",
                },
            ]
        },
        SearchsData() {
            let that = this
            let widthStyle = 'width: 160px;'
            return [{
                    label: "索赔单号",
                    key: 'CN_reimbursementNo',
                    show: true,
                    tag: 'vTextarea',
                    class:"inboundtext",
                    props:{
                        placeholder: this.$t('fbb.inbound.input_more_line', { defaultValue: "输入多个，一行一个" }),
                        rows:"1",
                    }
                },
                {
                    label: '项目',
                    key: 'EQ_lineId',
                    tag: 'vSelect',
                    show: true,
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "状态",
                    tag: 'vSelect',
                    key: 'EQ_status',
                    show: true,
                    options: this.statusList.filter(function (item) {
                        if(that.checkWarehouse){
                            return item.value == 5
                        }else{
                            return item.value != 1&&item.value != 6
                        }
                    })
                },
                {
                    label: "来源单号",
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    style: widthStyle,
                },
                {
                    label: "索赔类型",
                    tag: 'vSelect',
                    key: 'EQ_reimbursementType',
                    style: widthStyle,
                    options: this.reimbursementTypeList.filter(function (item) {
                        if(that.checkWarehouse){
                            return item.value !=2 &&item.value!=3
                        }else{
                            return item.value
                        }
                    })
                   /*  hideSearchTip: true,
                    on: {
                        'on-change': function (value) {
                            that.searchOptions.reimbursementReason = that.reimbursementTypeList.filter(item => {
                                return item.value == value
                            })[0].child
                        }
                    }, */
                },
                {
                    label: "索赔原因",
                    tag: 'vSelect',
                    key: 'EQ_reimbursementReason',
                    style: widthStyle,
                    /* hideSearchTip: true, */
                    options: this.reimbursementReasonList.filter(function (item) {
                        if(that.checkWarehouse){
                            return item.value ==1 ||item.value ==2||item.value ==3 ||item.value ==11 ||item.value ==12
                        }else{
                            return item.value
                        }
                    })
                },
                {
                    label: "发货Carrier",
                    tag: 'vInput',
                    key: 'CN_propsCarrier',
                    style: widthStyle,
                },
                {
                    label: "发货Tracking",
                    tag: 'vInput',
                    key: 'CN_propsTracking',
                    style: widthStyle,
                },   {
                    label: "尾程费用tracking",
                    tag: 'vInput',
                    key: 'CN_detailTracking',
                    style: widthStyle,
                },{
                    label: "复核日期",
                    tag: 'vDatepicker',
                    key: 'BT_reviewAt',
                    style: widthStyle,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                }, {
                    label: "仓库",
                    tag: 'vSelect',
                    key: 'CN_warehouseCode',
                    style: widthStyle,
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "SKU",
                    tag: 'vInput',
                    key: 'IN_propsSku',
                    style: widthStyle,
                },
                {
                    label: "caseId",
                    tag: 'vInput',
                    key: 'EQ_caseId',
                    style: widthStyle,
                },
                {
                    label: "提交人",
                    tag: 'vInput',
                    key: 'EQ_createdName',
                    style: widthStyle,
                },
                {
                    label: "提交时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    style: widthStyle,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: "更新时间",
                    tag: 'vDatepicker',
                    style: widthStyle,
                    key: 'BT_updatedAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                }, {
                    label: '客户组织',
                    key: 'EQ_organizationId',
                    tag: 'vSelect',
                    style: widthStyle,
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                },

            ]
        },
        columns() {
            return [{
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                }, {
                    title: '操作',
                    width: 70,
                    render: this.getOperateNodes
                }, {
                    title: '客户',
                    key: 'organizationId',
                    width: 100,
                    render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                }, {
                    title: '索赔单号/来源单号',
                    width: 120,
                    render: (h, {
                            row
                        }) => {
                            return <div><a onClick = {
                                    this.handleOperates.bind(this, row.id, 'query')
                                } > {
                                    row.reimbursementNo || '--'
                                } </a> <a onClick = {
                                this.handleOperates.bind(this, row.id, 'queryBlank')
                            } > < vIcon class = "margin-left-10 font-14"
                            type = "ios-browsers-outline" /> </a> {
                            /* <a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.inboundPlanOrderNo || '--'}</a> */
                        } <br/> {
                            row.sourceNo || '--'
                        } </div>
                }
            }, {
                title: '项目',
                maxWidth: 90,
                key: 'lineName',
                render: (h, {
                    row
                }) => this.findRenderLabel(this.getAllProduct, row.lineId)
            }, {
                title: '状态',
                key: 'status',
                width: 70,
                render: (h, {
                    row
                }) => {
                    const status = row.status;
                    const {
                        theme = 'default', label
                    } = this.statusList.find(function (item) {
                        return item.value == status
                    }) || {};
                    return <vButton ghost theme = {
                        theme
                    }
                    size = "small"
                    class = "cursor-not width-60" > {
                        label
                    } </vButton>
                }
            }, {
                title: '索赔类型/索赔原因',
                key: 'reimbursementType',
                width: 120,
                render: (h, {
                    row
                }) => {
                    return <div>
                        <div> {this.findRenderLabel(this.reimbursementTypeList, row.reimbursementType) || '--'} </div><div>{
                        this.findRenderLabel(this.reimbursementTypeList.filter(item => {
                            return item.value == row.reimbursementType
                        })[0].child, row.reimbursementReason) || '--'
                    } </div></div>
                }
            }, {
                title: '索赔金额',
                align: 'left',
                width: 60,
                render: (h, {
                    row
                }) => {
                    return <div > {
                        row.reimbursementAmount || '--'
                    } </div>
                }
            },{
                title: '实际赔偿金额（USD）',
                align: 'left',
                width: 100,
                render: (h, {
                    row
                }) => {
                    return <div >  {row.actualAmount || '--'} </div>
                }
            },{
                title: '实际发票金额',
                align: 'left',
                width: 80,
                render: (h, {
                    row
                }) => {
                    return <div >  {row.actualInvoiceAmount || '--'} </div>
                }
            },{
                title: 'caseId',
                align: 'left',
                width: 80,
                render: (h, {
                    row
                }) => {
                    return <div >  {row.caseId || '--'} </div>
                }
                },
                {
                    title: 'TrackingNo',
                    width: 100,
                    render: (h, { row }) => {
                        return <div>{row.trackingNo || '--'}</div>
                    }
                },
                {
                    title: '物流服务',
                    width:  140,
                    render: (h, { row }) => {
                        const props = row.props ? JSON.parse(row.props) : {};
                        return <div>{props.logisticsServiceCode || '--'}</div>;
                    }
                },
                {
                title: '复核日期',
                key: 'reviewAt',
                sortable: true,
                maxWidth: 100,
                render(h, {row}) {return <div> {row.reviewAt || '--'}</div>}
            },{
                title: '提交人',
                key: 'createdName',
                maxWidth: 80,
                render(h, {row}) {return <div> {row.createdName || '--'}</div>}
            }, {
                title: '提交时间/更新时间',
                width: 110,
                render(h, {row}) {
                    return <div><div> {row.createdAt || '--'} </div><div> {row.updatedAt || '--'} </div> </div>
                }
            },
        ];
    },

},
};
